module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table8E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位类别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("主要负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("其他负责人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("编辑人员")])], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("姓名：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.fullName),
      callback: function($$v) {
        _vm.$set(_vm.params, "fullName", $$v)
      },
      expression: "params.fullName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("性别：")]), _vm._v(" "), _c('td', {
    staticClass: "radioText"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.params.gender),
      callback: function($$v) {
        _vm.$set(_vm.params, "gender", $$v)
      },
      expression: "params.gender"
    }
  }, _vm._l((_vm.dicDats['C017']), function(item) {
    return _c('el-radio', {
      key: item.code,
      attrs: {
        "label": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("身份证号（军官证号）：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.idNumber),
      callback: function($$v) {
        _vm.$set(_vm.params, "idNumber", $$v)
      },
      expression: "params.idNumber"
    }
  })], 1)]), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职务：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "job",
      "inline-message": true
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "disabled": "",
      "placeholder": "请选择文化程度"
    },
    model: {
      value: (_vm.params.job),
      callback: function($$v) {
        _vm.$set(_vm.params, "job", $$v)
      },
      expression: "params.job"
    }
  }, _vm._l((_vm.dicDats['C022']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("政治面貌：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.politicalStatus),
      callback: function($$v) {
        _vm.$set(_vm.params, "politicalStatus", $$v)
      },
      expression: "params.politicalStatus"
    }
  }, _vm._l((_vm.dicDats['C006']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("文化程度：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.culture),
      callback: function($$v) {
        _vm.$set(_vm.params, "culture", $$v)
      },
      expression: "params.culture"
    }
  }, _vm._l((_vm.dicDats['C005']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("手机号：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.params, "cellphone", $$v)
      },
      expression: "params.cellphone"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("专业：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.major),
      callback: function($$v) {
        _vm.$set(_vm.params, "major", $$v)
      },
      expression: "params.major"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称系列：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.professionalTitleSeries),
      callback: function($$v) {
        _vm.$set(_vm.params, "professionalTitleSeries", $$v)
      },
      expression: "params.professionalTitleSeries"
    }
  }, _vm._l((_vm.dicDats['C007']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("职称级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.titleLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "titleLevel", $$v)
      },
      expression: "params.titleLevel"
    }
  }, _vm._l((_vm.dicDats['C008']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("持有出版专业职业资格证书情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.certificateSituation),
      callback: function($$v) {
        _vm.$set(_vm.params, "certificateSituation", $$v)
      },
      expression: "params.certificateSituation"
    }
  }, _vm._l((_vm.dicDats['C009']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("入职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.rzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "rzDate", $$v)
      },
      expression: "params.rzDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("离职时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.lzDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "lzDate", $$v)
      },
      expression: "params.lzDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("在职不填写")])], 1)]), _vm._v(" "), (_vm.params.professionalCertificateId && _vm.params.certificateSituation != 'ff8080816892204e0168fe6728c70902') ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("出版专业职业资格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.params.professionalCertificateId,
      "viewType": "2"
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否持有岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isTrainCertificate),
      callback: function($$v) {
        _vm.$set(_vm.params, "isTrainCertificate", $$v)
      },
      expression: "params.isTrainCertificate"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.trainCertificateId && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("取得岗位证书时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp areaTime"
  }, [_c('el-date-picker', {
    class: _vm.highLight == true ? 'highLight' : '',
    attrs: {
      "disabled": "",
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.params.trainCertificateDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "trainCertificateDate", $$v)
      },
      expression: "params.trainCertificateDate"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("岗位类别为主要负责人和其他负责人时需填写")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.params.trainCertificateId && _vm.params.type != 3) ? _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("岗位培训合格证书：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('Upbtn', {
    staticClass: "upBtn",
    attrs: {
      "ableSure": _vm.params.trainCertificateId,
      "viewType": "2"
    },
    on: {
      "upFileId": _vm.fileTdSet1
    }
  })], 1)]) : _vm._e()])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-8：人员基本情况登记表")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f43bec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table8.vue
// module id = 1764
// module chunks = 1